import React from 'react';
import styled, { css } from 'styled-components';

import { colors } from '@/constants/theme';
import { media } from '@/utils/mixin';

import { CreditInformationButtonProps } from './types';

function CreditInformationButton({
  type,
  minMonthPayment,
  onClick,
}: CreditInformationButtonProps) {
  return (
    <Component>
      <Content>
        <Badge>{type === 'credit' ? 'Кредит' : 'Лизинг'}</Badge>

        {type === 'credit' ? (
          <Text>Выгодный кредит</Text>
        ) : (
          <Text>Выгодный лизинг</Text>
        )}
      </Content>

      <Button onClick={onClick}>
        <ButtonTitle>
          {type === 'credit' ? 'Рассчитать кредит' : 'Рассчитать лизинг'}
        </ButtonTitle>

        <ButtonText>от {minMonthPayment} BYN/мес.</ButtonText>
      </Button>
    </Component>
  );
}

export default CreditInformationButton;

const Badge = styled.span`
  border-radius: 2px;
  font-weight: 700;
  font-size: 12px;
  line-height: 10px;
  padding: 8px 6px;
  display: inline-block;
`;

const Button = styled.button`
  padding: 0 10px;
  margin-left: 20px;
  width: 100%;
  max-width: 240px;
  height: 58px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
  color: ${colors.white};

  ${media.mobile(css`
    margin: 10px 0 0;
    max-width: none;
  `)}
`;

const Component = styled.div`
  padding: 12px 16px 12px 16px;
  background: ${colors.blue200};
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;

  ${Badge} {
    background: ${colors.green200};
    color: ${colors.green100};
  }

  ${Button} {
    background: ${colors.blue};

    &:hover {
      background: ${colors.blue500};
    }
  }

  ${media.mobile(css`
    flex-direction: column;
  `)}
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
`;

const Text = styled.p`
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: ${colors.black200};
  display: block;
  margin-top: 14px;
`;

const ButtonTitle = styled.span`
  display: block;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
`;

const ButtonText = styled.span`
  font-size: 12px;
  line-height: 14px;
  display: block;
  margin-top: 4px;
`;
